import dayjs from 'dayjs';
import { DateTime } from 'luxon';

export const calculateActualClockTimes = (
    scheduledStart: DateTime,
    clockInTime: dayjs.Dayjs,
    clockOutTime: dayjs.Dayjs,
    timezone: string
): { actualClockIn: DateTime; actualClockOut: DateTime } => {
    const shiftDate = scheduledStart.setZone(timezone).startOf('day');

    let actualClockIn = shiftDate.set({
        hour: clockInTime.hour(),
        minute: clockInTime.minute(),
    });
    // Only bump to next day if the clock-in is more than 12 hours before
    // the scheduled start — the time must belong to the following calendar day.
    // A smaller gap (e.g. clocking in 10 min early) should stay on the same day.
    if (scheduledStart.diff(actualClockIn, 'hours').hours > 12) {
        actualClockIn = actualClockIn.plus({ days: 1 });
    }

    let actualClockOut = shiftDate.set({
        hour: clockOutTime.hour(),
        minute: clockOutTime.minute(),
    });
    if (actualClockOut < actualClockIn) {
        actualClockOut = actualClockOut.plus({ days: 1 });
    }

    return { actualClockIn, actualClockOut };
};
